import React from 'react';

const AllReviewsPopup = ({ reviews, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex justify-center items-start max-md:items-end pt-12 max-md:pt-0 px-2 max-md:px-0">
            <div className="bg-white rounded-lg max-md:rounded-b-none max-md:rounded-t-3xl shadow-xl p-6 w-full max-w-6xl max-h-[90vh] max-md:max-h-[85vh] overflow-y-auto">
                <div className="md:hidden flex justify-center -mt-2 mb-3">
                    <span className="w-10 h-1 rounded-full bg-gray-300" />
                </div>
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-2xl font-semibold text-[var(--brand-primary-700)]">All Reviews</h3>
                    <button
                        onClick={onClose}
                        className="text-red-500 font-bold text-lg hover:text-red-700"
                    >
                        ✕
                    </button>
                </div>
                <div className="flex flex-wrap gap-4 justify-between mt-8 overflow-hidden">
                    {reviews.filter(review => review.showReview || review.showHide).map((review) => (
                        <div
                            key={review._id}
                            className="
                basis-full
                sm:basis-[48%]
                md:basis-[32%]
                max-w-full
                sm:max-w-[48%]
                md:max-w-[32%]
                border p-4 rounded-lg shadow-md relative pb-7 bg-white
            "
                        >
                            <h3 className="font-bold text-lg text-[var(--brand-primary-600)]">{review.reviewTitle}</h3>
                            <p className="text-gray-600 mt-1">{review.review}</p>
                            <div className="flex items-center space-x-1 text-yellow-400 mt-2">
                                {Array.from({ length: review.rating }, (_, i) => (
                                    <span key={i}>⭐</span>
                                ))}
                            </div>

                            {review.reviewImage && (
                                <img crossOrigin="anonymous" 
                                    src={review.reviewImage}
                                    alt="Review"
                                    className="mt-3 rounded-md object-cover w-full h-auto max-h-48"
                                />
                            )}
                            <p className="text-[var(--brand-primary-500)] text-sm absolute bottom-2">By: {review.name}</p>
                        </div>
                    ))}
                </div>


            </div>
        </div>
    );
};

export default AllReviewsPopup;
